import { useCatalogProductIdParams, useGetPdpIntegratedData } from '@domains/pdp-common';

import { toSizeRecommendation } from '../utils/mapper';

export const useLegacySizeRecommendationService = () => {
  const { catalog_product_id } = useCatalogProductIdParams();
  const { size_recommendation, refetch } = useGetPdpIntegratedData({
    catalog_product_id,
  });

  const sizeRecommendation = toSizeRecommendation(size_recommendation);

  return {
    catalogProductId: catalog_product_id,
    visible: Boolean(size_recommendation),
    sizeRecommendation,
    recommendOptionValueList: sizeRecommendation.recommendOptionValueList,
    recommendationType: sizeRecommendation.recommendationType,
    userAccount: sizeRecommendation.userAccount,
    refetch,
  };
};
